import request from "@/config/utils/request";

// 附件预览 文件地址解密
export function getFileUrlSecret(data) {
  return request({
    url: "/apis/sp/oss/getFileUrlSecret",
    method: "post",
    data
  });
}
